export class ResiNotEnrolledException extends Error {}
